import { Box, useTheme, TextField, Button } from "@mui/material";
import { DataGrid, esES } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { tokens } from "../../../../theme";
import { getTrackingBoxeRoute } from "../../../../config";
import FatalError from "../../../global/FatalError";
import Loading from "../../../global/Loading";
import Header from "../../../../components/Header";
import swal from "sweetalert";
import { format } from 'date-fns';
import React from 'react';
import { useLocation } from "react-router-dom";

const Tracking = ({permissionsListData}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const _id = query.get('id');

  const [ loadingRequest, setLoadingRequest ] = useState(false);
  const [ errorRequest, setErrorRequest ] = useState(null);

  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const getBoxTracking = async(id_box) =>{
    if(id_box && id_box !== "" ){
      try{
        setLoadingRequest(true)
        let res = await fetch(getTrackingBoxeRoute(id_box), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept":"application/json",
          },
        })
        let data = await res.json()
        if(res.ok){
          setRecord(data)
        }else{
          if(res.status === 404){
            mostrarAlertRequest("Caja no encontrada")
            setRecord(null)
          }
        }
        setLoadingRequest(false)
        return data;
      }catch(errorRequest){
        setLoadingRequest(false)
        setErrorRequest(errorRequest)
      }
    }
  }

  const [record, setRecord] = useState(null);

  const searchFormik = useFormik({
      initialValues: {
        recordId: '',
      },
      onSubmit: (values) => {
        getBoxTracking(values.recordId)
      },
  });

  const handleInitialSearch = () => {
    if (_id) {
      searchFormik.setFieldValue('recordId', _id, false);
      searchFormik.submitForm();
    }
  };

  useEffect(() => {
    handleInitialSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id]);

  const mostrarAlertRequest=(info)=>{
    if(info!=null){
      try{
        swal({
          title:"Alerta",
          text: info,
          icon: "warning",
          button:"Aceptar"
        })
      }catch(e){
        swal({
          title:"Error",
          text: "Error inesperado ",
          icon: "error",
          button:"Aceptar"
        })
      }
    }
  }

  const customLocaleText = {
    ...esES.components.MuiDataGrid.defaultProps.localeText,
    noRowsLabel: 'No hay se encontraron resultados...',
  };

  const formatDateTime = (value) => {
    const date = new Date(value);
    return isNaN(date) ? "" : format(date, 'yyyy-MM-dd HH:mm');
  };

  const columns=[
    {
      flex:1,
      field:"description_status",
      headerName: "Descripción",
      cellClassName: "description_status-column--cell",
    },
    {
      flex:1,
      field:"status",
      headerName: "Estado",
      cellClassName: "status-column--cell",
    },
    {
      flex:1,
      field:"history_date",
      headerName: "Fecha",
      minWidth:100,
      renderCell: ({ row: { history_date} }) => formatDateTime(history_date)
    },
  ]

  if(loadingRequest)
  return(<Loading/>)

  if(errorRequest)
  return(<FatalError/>)

  return (
    <Box m="20px" marginBottom="64px">
      <Header title="Tracking" subtitle="Ingrese la caja a buscar" />

      <form onSubmit={searchFormik.handleSubmit}>
        <Box display="flex" justifyContent="flex-start" alignItems="center" gap={2} pb={2}>
          <TextField
            variant="filled"
            label="Código de caja"
            name="recordId"
            value={searchFormik.values.recordId}
            onChange={searchFormik.handleChange}
            size="small"
          />
          <Button type="submit" variant="contained" color="secondary">
            Buscar
          </Button>
        </Box>
      </form>

      {record && (
        <Box sx={{
          mt: 1,
          mb: "50px",
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
            color: "white",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
          "& .MuiToolbar-gutters": { color: "white" },
          "& .MuiTablePagination-root": { color: "white" },
          "& .MuiTablePagination-selectIcon": { color: "white" },
          "& .MuiTablePagination-actions button": { color: "white" },
        }}>
          <DataGrid
            autoHeight
            initialState={{
              columns: {
                columnVisibilityModel: { id: false },
              },
            }}
            localeText={customLocaleText}
            rows={record}
            columns={columns}
            sortModel={sortModel}
            onSortModelChange={(newModel) => setSortModel(newModel)}
            getRowId={(row) => row.id}
            density="compact"
          />
        </Box>
      )}
    </Box>
  );
}

export default Tracking;
